import React, { Component } from "react";
import axios from "axios";
import { admission, mua } from "../config/api";


export default class Checkcrackpresent extends Component {

    componentDidMount() {
        axios.get(mua + "/admissionnew2022/showlistregister?id=" + this.props.match.params.id).then((res) => {
            if (res.data.data.data.length !== 0) {
                res.data.data.data = res.data.data.data.filter(({ REGISTER_STATUS }) => !(REGISTER_STATUS === "11" || REGISTER_STATUS === "91" || REGISTER_STATUS === "12" || REGISTER_STATUS === "5" || REGISTER_STATUS === "41"));
                if (res.data.data.data[0]["REGISTER_STATUS"] === "0" || res.data.data.data[0]["REGISTER_STATUS"] === "1" || res.data.data.data[0]["REGISTER_STATUS"] === "2" || res.data.data.data[0]["REGISTER_STATUS"] === "3" || res.data.data.data[0]["REGISTER_STATUS"] === "4" || res.data.data.data[0]["REGISTER_STATUS"] === "5") {
                    localStorage.setItem("citizent", this.props.match.params.id);
                    localStorage.setItem("ID_LOGIN", res.data.data.data[0]["ID_LOGIN"]);
                    window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Dataregister`;
                } else if (res.data.data.data[0]["REGISTER_STATUS"] === "6" || res.data.data.data[0]["REGISTER_STATUS"] === "7" || res.data.data.data[0]["REGISTER_STATUS"] === "8" || res.data.data.data[0]["REGISTER_STATUS"] === "9") {
                    if (res.data.data.data[0]["ROB_ID"] !== "107") {
                        localStorage.setItem("citizent", this.props.match.params.id);
                        localStorage.setItem("ID_LOGIN", res.data.data.data[0]["ID_LOGIN"]);
                        if (res.data.data.data[0]["Major1_MAJOR_ID"] === "9902") {
                            if (res.data.data.data[0]["REGISTER_STATUS_BILL_ROB1_BOOK"] || res.data.data.data[0]["REGISTER_STATUS_BILL_ROBFULL_BOOK"] ) {
                                localStorage.setItem("statusHeader", "1");
                                axios.get(admission + "/student/creckprecent1/" + res.data.data.data[0]["REGISTER_ID"]).then((response) => {
                                    if (response.data === 0) {
                                        window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Insertpresent1`;
                                    } else {
                                        window.location.href = `${process.env.REACT_APP_BASENAME || ""}/present`;
                                    }
                                })
                            } else {
                                window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Checkpresent`;
                            }
                        } else {
                            if (res.data.data.data[0]["REGISTER_STATUS_BILL_ROBFULL_BOOK"]) {
                                localStorage.setItem("statusHeader", "1");
                                axios.get(admission + "/student/creckprecent1/" + res.data.data.data[0]["REGISTER_ID"]).then((response) => {
                                    if (response.data === 0) {
                                        window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Insertpresent1`;
                                    } else {
                                        window.location.href = `${process.env.REACT_APP_BASENAME || ""}/present`;
                                    }
                                })
                            } else if (res.data.data.data[0]["REGISTER_STATUS_BILL_ROB1_BOOK"]) {
                                if (res.data.data.data[0]["REGISTER_STATUS_BILL_ROB2_BOOK"]) {
                                    localStorage.setItem("statusHeader", "1");
                                    axios.get(admission + "/student/creckprecent1/" + res.data.data.data[0]["REGISTER_ID"]).then((response) => {
                                        if (response.data === 0) {
                                            window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Insertpresent1`;
                                        } else {
                                            window.location.href = `${process.env.REACT_APP_BASENAME || ""}/present`;
                                        }
                                    })
                                } else {
                                    localStorage.setItem("statusHeader", "1");
                                    axios.get(admission + "/student/creckprecent1/" + res.data.data.data[0]["REGISTER_ID"]).then((response) => {
                                        if (response.data === 0) {
                                            window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Insertpresent1`;
                                        } else {
                                            window.location.href = `${process.env.REACT_APP_BASENAME || ""}/present`;
                                        }
                                    })
                                    // window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Checkpresent`;
                                }
                            } else {
                                // window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Checkpresent`;
                            }
                        }
                    } else {
                        localStorage.setItem("citizent", this.props.match.params.id);
                        localStorage.setItem("ID_LOGIN", res.data.data.data[0]["ID_LOGIN"]);
                        localStorage.setItem("statusHeader", "1");
                        window.location.href = `${process.env.REACT_APP_BASENAME || ""}/present`;
                        // window.location.href = admission + "/student_creckregister?ic="+res.data.data.data[0]["ID_LOGIN"];
                    }
                }
            }
        })
    }

    render() {
        return (<></>)
    }
}

